console.log("Started");

window.CartCountdown = (function () {
  const STORAGE_KEY = 'store_countdown_expires_at';
  const DURATION_MS = 25 * 60 * 1000;
  const registered = new Set();

  function now() {
    return Date.now();
  }

  function getExpiry() {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? parseInt(raw, 10) : NaN;

    if (!Number.isFinite(parsed) || parsed <= now()) {
      const fresh = now() + DURATION_MS;
      localStorage.setItem(STORAGE_KEY, String(fresh));
      return fresh;
    }

    return parsed;
  }

  function getRemainingMs() {
    return Math.max(0, getExpiry() - now());
  }

  function format(ms) {
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }

  function renderElement(el) {
    if (!el || !document.contains(el)) return;
    el.textContent = format(getRemainingMs());
  }

  function renderAll() {
    registered.forEach((el) => {
      if (!document.contains(el)) {
        registered.delete(el);
        return;
      }
      renderElement(el);
    });

    document.querySelectorAll('[data-store-countdown]').forEach(renderElement);

    renderElement(document.querySelector('.needsclick strong'));
  }

  function register(el) {
    if (!el) return false;
    registered.add(el);
    renderElement(el);
    return true;
  }

  setInterval(renderAll, 1000);

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) renderAll();
  });

  return {
    register,
    renderAll,
    getRemainingMs
  };
})();

